import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';
import { UiKitModule } from '../../../shared/modules/ui-kit/ui-kit.module';
import { ReportService } from '../../../services/report.service';

@Component({
  selector: 'app-cartola-de-movimientos',
  standalone: true,
  imports: [
    CommonModule,
    CommonNgModule,
    UiKitModule
  ],
  providers:[
    ReportService
  ],
  templateUrl: './cartola-de-movimientos.component.html',
  styleUrl: './cartola-de-movimientos.component.scss'
})
export class CartolaDeMovimientosComponent {
  @Input() CurrentRutUser:any;
  @Input() TypeApp:any;
  origen:any;
  constructor(
    private readonly reportService: ReportService
  ){}
  downloadCartola(){
    // alert('Descarga cartola.');
    // console.log('this.CurrentRutUser', this.TypeApp);
    // console.log('this.CurrentRutUser typo', typeof this.TypeApp);
    // SA = SITIO PRIVADO
    // SI = CONSULTA INTEGRAL
    // SP = SITIO PUBLICO
    // SM = APP MOVIL
    switch (this.TypeApp) {
      case '0':
        this.origen = 'SA';
      break;
      case '1':
        this.origen = 'SP';
      break;
      case '2':
        this.origen = 'SM';
      break;
      case '3':
        this.origen = 'SI';
      break;
    }

    // console.log('this.origen', this.origen);
    this.reportService.downloadFile('PlanPagoRestitucion', 'PlanPagoRestitucion', 'pdf', {
      "RUT_AFILIADO": this.CurrentRutUser,
      "ORIGEN": this.origen
    } );

  }
}
